import React from "react";
import * as images from "../../assets";
import { imgQRCode } from "../../assets";
import Button from "../../shared/buttons";
import Heading from "../../shared/headings";
import Paragraph from "../../shared/paragraphs";
import { DadosParceiro } from "./mock";
import {
  Container,
  Content,
  FirstSection,
  FouthSection,
  Image,
  LastSection,
  SecondSection,
  ThirdSection,
} from "./styles";

function Help() {
  return (
    <>
      <Container>
        <Content>
          <Heading text="Como ajudar" size="h2" />
          <div className="sessaoDoacoes">
            <Heading text="Doações" size="h3" />
            <div>
              <Paragraph text="Sugerimos doações no valor de" type="P2" />
              <Paragraph text="R$10, R$25, R$50 ou R$100" type="P2" />
              <Paragraph
                text=", mas qualquer valor é muito bem vindo!"
                type="P2"
              />
            </div>
          </div>
          <div className="sessaoPix">
            <Paragraph text="PIX" type="P" />
            <section>
              <div>
                <Paragraph text="Nossa chave PIX é:" type="P2" />
                <Paragraph
                  text="40.821.523/0001-13"
                  type="P2"
                  className="textBold"
                />
              </div>
              <div>
                <Paragraph text="Destinatário:" type="P2" />
                <Paragraph
                  text="Associação Circuito Inclusão"
                  type="P2"
                  className="textBold"
                />
              </div>
              
            </section>
          </div>
          <FirstSection>
            <Image src={imgQRCode} alt="qr code" srcset="" />
            <Image src={images.imagem1} alt="qr code" srcset="" />

            <div>
              <Paragraph
                text="Para doar utilizando PIX, siga as orientações abaixo:"
                type="P3"
              />
              <ul>
                <li>abra a área PIX/QR code no app do seu banco;</li>
                <li>
                  aponte a câmera do seu celular para o QR code a esquerda;
                </li>
                <li>scolha o valor que deseja doar; confirme a transação.</li>
              </ul>

              <Paragraph
                text="Destinatário: Associação Circuito Inclusão"
                type="P3"
              />
            </div>
          </FirstSection>
          <SecondSection>
            <Heading text="Para depósitos ou transferências" size="h3" />
            <section>
              <div className="sessao">
                <div>
                  <div className="block1">
                    <Heading text="Instituição: 403 - Cora SCD" size="h4" />
                    <ul>
                      <li>Agência: 0001</li>
                      <li>Conta: 1228114-5</li>
                      <li>Nome da Empresa: Associação Circuito Inclusão</li>
                      <li>CNPJ: 40.821.523/0001-13</li>
                    </ul>
                  </div>
                  <div className="block1">
                    <Heading
                      text="Instituição: 001 - Banco do Brasil"
                      size="h4"
                    />
                    <ul>
                      <li>Agência: 2818-5</li>
                      <li>Conta: 54155-9</li>
                      <li>Nome da Empresa: Associação Circuito Inclusão</li>
                      <li>CNPJ: 40.821.523/0001-13</li>
                    </ul>
                  </div>
                </div>
                <div className="SectionImages">
                  <Image src={images.imagem2} />
                  <div>
                    <Image src={images.imagem1} />
                    <Image src={images.imagem3} />
                  </div>
                </div>
              </div>
              <div className="sessao2">
                <Heading text="Cartão de Crédito" size="h3" />
                <div>
                  <Paragraph
                    text="Caso queira utilizar um cartão de crédito para doação, acesse o link abaixo e preencha os dados, nessa opção também é possível fazer doações mensais recorrentes."
                    type="P2"
                  />
                  <a href="https://doeonline.org/circuitoinclusao/doe">
                    <Paragraph
                      text="https://doeonline.org/circuitoinclusao/doe"
                      type="P2"
                    />
                  </a>
                </div>
                <img src={images.imagem3} alt="phot" />
              </div>
            </section>
          </SecondSection>
          <ThirdSection>
            <div className="first-section">
              <Heading text="Aluguel de brinquedos inclusivos" size="h3" />
              <p>
                Através do aluguel <strong>Brinquedos inclusivos </strong>
                Você ajuda a manter o circuito inclusão, além de promover
                inclusão e diversidade em sua festa ou evento.
              </p>
              <img src={images.imagem4} alt="phot" />
            </div>
            <div className="second-section">
              <Paragraph text="Como funciona?" type="P2" />
              <Paragraph
                text="É simples! Basta enviar um e-mail (circuitoinclusão@gmail.com) para nós solicitando que verificamos a disponibilidade. Pedimos que a solicitação seja feita com uma semana de antecedência para verificarmos a condição dos brinquedos e questão logística. Ajudamos com a montagem dos brinquedos e sempre teremos alguém da nossa equipe auxiliando durante o evento."
                type="P2"
              />
              <img src={images.imagem5} alt="phot" />

            </div>
            <div className="Container">
              <div className="block1">
                <Paragraph
                  type="P2"
                  text="O transporte é feito via caminhão S4, kombi ou caminhonete, a entrega é combinada com o cliente."
                />
                <Heading text="Temos cinco opções de brinquedos:" size="h4" />
                <ul>
                  <li>Carrinho de rolimã adaptado</li>
                  <li>Skate inclusivo</li>
                  <li>Tirolesa</li>
                  <li>Balanço inclusivo</li>
                  <li>Gangorra inclusivo</li>
                </ul>
                <Paragraph text="*O Valor do aluguel será informado no e-mail da solicitação." />
                <img src={images.imagem6} alt="phot" />
              </div>
              <div className="SectionImages2">
                <Image src={images.imagem5} />
                <div>
                  <Image src={images.imagem4} />
                  <Image src={images.imagem6} />
                </div>
              </div>
            </div>
          </ThirdSection>
          <FouthSection>
            <Heading text="Voluntários" size="h3" />
            <Paragraph text="Estamos abertos para receber voluntários, seja nas atividades cotidianas do Circuito Inclusão, assim como nos eventos que realizamos. Sentiu que pode ajudar de alguma forma?" />
            <Paragraph text="Entre em contato conosco através do e-mail circuitoinclusao@gmail.com e informe seu nome, telefone para contato e conte-nos o que você gostaria de fazer para apoiar a nossa causa." />
            <div className="cards">
              <Image src={images.imagem7} alt="img" />
              <Image src={images.imagem8} alt="img" />
              <Image src={images.imagem9} alt="img" />
            </div>
            <Button 
              text="Quero ser voluntário"
              size="medium"
              typeButton="primary"
            />
            <Heading text="Palestras" size="h3" />
            <Paragraph text="Realizamos palestras sobre inclusão e temáticas que permeiam o assunto, baseadas nas nossas experiências com o Circuito Inclusão. Caso queira essa discussão em sua comunidade, trabalho, escola, dentre outros ambientes, entre em contato conosco." />
            <img className="img" src={images.imagem9} alt="img" />
            <Heading text="Seja uma empresa parceira" size="h3" />
            <Paragraph text="Procuramos sempre nos unir com empresas que estejam dispostas a apoiar a nossa causa. Se você e sua empresa sentem que podem contribuir com a nossa causa de alguma forma, contate-nos." />
            <img className="img" src={images.imagem8} alt="img" />
          </FouthSection>
          <LastSection>
            <Heading text="NOSSOS PARCEIROS" size="h2" />
            <section className="cardsParceiros">
              {DadosParceiro.map((item, index) => (
                <img key={index} {...item} alt={item.alt} />
              ))}
            </section>
          </LastSection>
        </Content>
      </Container>
    </>
  );
}

export default Help;
